import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFeedbackConfig,
  fetchHairAnalysis,
} from "../../services/analysis";

const initialState = {
  hairAnalysisResult: undefined,
  isOpenSWW: false,
  faceId: undefined,
  feedbackConfig: undefined,
};

const analysisSlice = createSlice({
  name: "analysis",
  initialState,
  reducers: {
    setIsOpenSWW: (state, action) => {
      state.isOpenSWW = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchHairAnalysis.fulfilled, (state, action) => {
      state.hairAnalysisResult = action.payload.data.analysis
        ? action.payload.data.analysis
        : action.payload.data;
      state.faceId = action.payload.data.faceId;
    });
    builder.addCase(fetchHairAnalysis.rejected, (state, action) => {
      state.isOpenSWW = true;
    });
    builder.addCase(fetchFeedbackConfig.fulfilled, (state, action) => {
      state.feedbackConfig = action.payload;
    });
  },
});

export const { setIsOpenSWW } = analysisSlice.actions;

export default analysisSlice.reducer;
